exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".roleLabel{margin-top:10px}.ui-menu .ui-menu-list .ui-menuitem .ui-menu-child{width:11.2rem}", ""]);

// exports
